import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import './yarn-count-list.scss';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import YarnCountService from '../../services/yarn-count.service';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
// import transporterService from '../../services/transporter.service';
// import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
// import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import moment from 'moment';
import CheckDuplicate from '../check-duplicate/check-duplicate'

export default function YarnCountAdd(props) {
  const [yarnCountValue, setYarnCountValue] = useState();
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [checkDuplicateValue, setCheckDuplicateValue] = useState('');
  useEffect(() => {
  setTimeout(() => {
    
    // YarnCountID ,YarnThread ,YarnQualityID ,YarnTypeID
    console.log({
      YarnCount:yarnCountValue,
      
      checkDuplicate
    })
    if(yarnCountValue != undefined && checkDuplicate == true){
      console.log(props.dataList)
      let check = CheckDuplicate.withCombination(props.dataList,['YarnCount'],{
        YarnCount:yarnCountValue,
      
      })
      console.log(check)
      
      if(!check){
        document.querySelector('#yarnCountGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='visible';
        setCheckDuplicateValue('')
      }else{
        document.querySelector('#yarnCountGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='hidden';
        setCheckDuplicateValue('Duplicate Value Detected!')
    }
   }
  }, 500);
  }, [yarnCountValue ]);

  const useStyles = makeStyles((theme) => ({
    fromWrapper: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(8),
    },
  }));

  useEffect(() => {
    // getYarnCompanies();
    // getYarnBrands();
    // getProcurementTypes();
    // getCurrencies();
    // getDeliveryStatus();
    // getPaymentTerms();
    // getImportLCs();
    // getFullYarnCounts();
  }, []);


  const INITIAL_FORM_STATE = {
    // TransporterId: '',
    YarnCount: '',
    WarpWastagePercent: 0,
    WeftWastagePercent: 0,
  };

  const FORM_VALIDATION = Yup.object().shape({
    // OrderId: Yup.string().required('Required'),
    YarnCount: Yup.string().required('Required'),
    WarpWastagePercent: Yup.string().required('Required'),
    WeftWastagePercent: Yup.string().required('Required'),
  });

  
  const fields: object = { text: 'value', value: 'id' };

  const classes = useStyles();

  const minDate: Date = new Date(moment().startOf('day'));


  return (
    <div className='yarn-contract-container'
    onKeyDown={(e)=> e.stopPropagation()}
    >
<div className='backgroundImg'></div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className='heading'>
            <h3 style={{ textAlign:'center', width: '100%' }}>Yarn Count - Add</h3>
          </div>
          
        </Grid>

        <Grid item xs={12}>
          <Container>
            <div >
              <Formik
                initialValues={{
                  ...INITIAL_FORM_STATE,
                }}
                validationSchema={FORM_VALIDATION}
                onSubmit={async (values) => {
                  console.log('form values: ', values);
                  return new Promise((res) => {
                    YarnCountService.create(values).then(
                      (response) => {
                        console.log('response: ', response);
                      }
                    );
                    setTimeout(res, 2500);
                  });
                }}
              >
                {({ values, errors, isSubmitting }) => (
                  <div>
                    {/* <pre> {JSON.stringify({ values, errors }, null, 4)} </pre> */}
                    <Grid container spacing={2}>
                      
                      
                      <Grid item xs={6}>
                        <TextBoxComponent
                          className='e-input'
                          type='number'
                          placeholder='Yarn Count'
                          name='YarnCount'
                          floatLabelType='Auto'
                          value={yarnCountValue}
                          onChange={(e)=> {
                            setCheckDuplicate(true)
                            setYarnCountValue(e.value)}}
                        />
                      </Grid>
                      
                      <Grid item xs={6}>
                        <TextBoxComponent
                          className='e-input'
                          type='number'
                          placeholder='Warp Wastage %'
                          name='WarpWastagePercent'
                          floatLabelType='Auto'
                          // onChange={updateCalculations}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextBoxComponent
                          className='e-input'
                          type='number'
                          placeholder='Weft Wastage %'
                          name='WeftWastagePercent'
                          floatLabelType='Auto'
                          // onChange={updateCalculations}
                        />
                      </Grid>

                    </Grid>
                  </div>
                )}
              </Formik>
            </div>
          </Container>
        </Grid>
      </Grid>
      <h3 className="duplicate " style={checkDuplicateValue != '' ? {transform:'scale(1)'}:{}}>{checkDuplicateValue}</h3>

    </div>
  );
}
